import type { PaletteProps } from 'pixelize-design-library';

import {
  accentInk,
  accentTint,
  mutedText,
  ruleBorder,
  statusFill,
  statusInk,
  statusTint,
  type SemanticTone
} from '@core/Theme/tokens';

export type UiTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral' | 'accent';

export interface ToneColors {
  ink: string;
  tint: string;
  edge: string;
}

const SEMANTIC: Partial<Record<UiTone, SemanticTone>> = {
  success: 'success',
  warning: 'warning',
  danger: 'error',
  info: 'info'
};

export function toneColors(colors: PaletteProps, tone: UiTone): ToneColors {
  const semantic = SEMANTIC[tone];
  if (semantic) {
    return {
      ink: statusInk(colors, semantic),
      tint: statusTint(colors, semantic),
      edge: statusFill(colors, semantic)
    };
  }
  if (tone === 'accent') {
    return { ink: accentInk(colors), tint: accentTint(colors), edge: colors.primary[500] };
  }
  return { ink: mutedText(colors), tint: colors.gray[100], edge: ruleBorder(colors) };
}
